import type { FunctionComponent, CSSProperties } from 'react';
import css from './FallbackImage.module.less';

export type FallbackImageProps = {
  src: 'no-results' | 'error-plug' | 'tada' | 'circle-checkmark' | '404-cat' | 'list-tree' | 'no-data';
  alt: string;
  hasPadding?: boolean;
};

/**
 * A FallbackImage represents a static image that appears when backend errors
 * occur or when there are no results to display. Other circumstances may
 * be added in the future.
 */
const FallbackImage: FunctionComponent<FallbackImageProps> = ({
  children,
  src,
  alt,
  hasPadding = false,
}) => {
  const style: CSSProperties = {};
  if (hasPadding) {
    style.padding = '72px 0';
  }

  return (
    <div className={css.wrapper} style={style}>
      <img className={css.image} src={`/img/${src}.svg`} alt={alt} />
      <div className={css.content}>
        { children }
      </div>
    </div>
  );
};

export default FallbackImage;
